import React from 'react'
import { Text } from '@wework/dieter-ui'

export default function HoldNotice({ space }) {
  if (!space) {
    return null
  }

  const isOnHold = () => {
    if (!space) {
      return false
    }

    if (space.note?.length > 0 || space.contracts || space.hold) {
      return true
    }

    return false
  }
  if (!isOnHold()) return null
  return (
    <div
      style={{
        background: '#FFFDE5',
        display: 'flex',
        alignItems: 'center',
        marginTop: 24,
        padding: '8px 12px',
      }}
    >
      <Text size="tiny" style={{ color: '#665E00' }}>
        ⚠️ This space has an existing hold, paperwork, or office note. To update
        this space, please coordinate with the respective Sales / Community
        team.
      </Text>
    </div>
  )
}
